// Extrai a mensagem exibível de um erro de requisição — issue #217.
//
// POR QUE EXISTE: esta função estava duplicada em Camera/AlterarSenha e
// Camera/CadastrarUsuario, e as duas cópias já tinham DIVERGIDO — a segunda
// perdeu o caso 401 ("Sessão expirada"), então a mesma falha produzia telas
// diferentes. O services/api.js ainda tinha uma terceira versão da mesma ideia
// (`mensagemDoErro`). Três implementações, nenhuma reaproveitável.
//
// Os controllers do backend não são consistentes: a maioria usa a chave `erro`,
// alguns usam `error`, e a API de câmera (FastAPI) usa `detail`. A ordem abaixo
// cobre os três. Desde a #169 a mensagem do backend costuma vir acompanhada de
// um código de correlação ("... Código: A3F92."), que o suporte usa para achar
// a ocorrência no log — por isso vale mostrar o texto do servidor sempre que
// existir, em vez de substituí-lo por um genérico da tela.
//
// `mensagensPorStatus` permite que a tela sobreponha um status específico sem
// reescrever a função. É como as telas de câmera mantêm o texto delas para 503
// ("Verifique se a VPN está ativa"), que seria errado numa tela de Férias.

const GENERICAS = {
  400: 'Dados inválidos. Verifique os campos e tente novamente.',
  401: 'Sessão expirada. Faça login novamente.',
  403: 'Sem permissão para realizar esta operação.',
  503: 'Serviço temporariamente indisponível. Tente novamente em instantes.',
};

export default function resolverMensagemErro(err, mensagensPorStatus = {}) {
  const data = err?.response?.data;
  const status = err?.response?.status;

  if (typeof data === 'string' && data.trim()) return data;
  if (data?.erro) return data.erro;
  if (data?.error) return data.error;
  if (data?.detail) {
    if (typeof data.detail === 'string') return data.detail;
    if (Array.isArray(data.detail)) return data.detail.map(d => d.msg).join('; ');
  }

  if (mensagensPorStatus[status]) return mensagensPorStatus[status];
  if (GENERICAS[status]) return GENERICAS[status];
  if (status >= 500) return 'Erro interno no servidor. Tente novamente em instantes.';

  return err?.message || 'Erro ao enviar requisição.';
}
